import styled from 'styled-components';
import { Button } from '../../../ui/button/Button';

export default styled(Button).attrs((props) => ({
  dataAt: props.dataAt,
}))`
  background-color: ${(props) => props.theme.colors.primaryLightBlue};
`;
